import React from 'react';
import { parseTextWithLinks, normalizeUrl } from '../../lib/textUtils';

interface LinkifiedTextProps {
  text: string;
}

/**
 * Component that renders text with clickable links
 * URLs are converted to clickable <a> tags
 */
export function LinkifiedText({ text }: LinkifiedTextProps) {
  const parts = parseTextWithLinks(text);

  return (
    <>
      {parts.map((part, index) => {
        if (part.type === 'link') {
          const href = normalizeUrl(part.content);
          return (
            <a
              key={index}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800 break-all"
            >
              {part.content}
            </a>
          );
        }
        return <span key={index}>{part.content}</span>;
      })}
    </>
  );
}
